export default __webpack_public_path__ + "static/media/ENABLED.2e799060.png";